import { IErrorLayout } from '@shared/layouts/ErrorLayout';

export const NOT_FOUNDED: IErrorLayout = {
  title: 'Ошибка 404',
  subtitle: 'Перезагрузите страницу или нажмите кнопку ниже',
};
export const BAD_REQUEST: IErrorLayout = {
  title: 'Ошибка 400',
  subtitle: 'Перезагрузите страницу или нажмите кнопку ниже',
};
export const FORBIDDEN: IErrorLayout = {
  title: 'Ошибка 403',
  subtitle: 'Перезагрузите страницу или нажмите кнопку ниже',
};

export const UNKNOWN_ERROR: IErrorLayout = {
  title: 'Неизвестная ошибка',
  subtitle: 'Перезагрузите страницу или нажмите кнопку ниже',
};

export const ERROR_FOR_REMOTE: IErrorLayout = {
  title: 'Билет недействителен',
  subtitle: 'Билет был отозван организатором мероприятия',
};

export const UNCAUGHT_ERROR: IErrorLayout = {
  title: 'Неизвестная ошибка',
  subtitle: 'Перезагрузите страницу',
};
